export class FormModel {
    public Name: string;
    public Email: string;
    public Option: string;
    public Text: string;
}

